exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content-layout[data-v-4e1b22f7]{width:1200px;margin:0 auto;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.content-layout .l[data-v-4e1b22f7]{width:860px}.content-layout .r[data-v-4e1b22f7]{width:300px}", ""]);

// exports
